<script lang="ts" module>
  namespace LoadingArea {
    export interface Props {
      class?: string;
    }
  }
</script>

<script lang="ts">
  let { class: className }: LoadingArea.Props = $props();
</script>

<div class={`relative w-full overflow-hidden ${className || ''}`}>
  <div
    class="absolute -left-[100%] h-full w-[200%] animate-loading-slide rounded-sm bg-gradient-to-r from-prim-H via-prim to-prim-H bg-repeat"
    style="background-size: 50%, 100%;"
  ></div>
</div>
